var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "in_progress",
    transform: "translate(-1685 -695)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11411",
    "data-name": "Rectangle 11411",
    width: 24,
    height: 24,
    transform: "translate(1685 695)",
    fill: "#eaecf2",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_hourglass",
    d: "M7.984,2.986A1,1,0,0,0,7.84,3H6A1,1,0,1,0,6,5H7V6.344A5,5,0,0,0,8.465,9.879L10.586,12,8.465,14.121A5,5,0,0,0,7,17.656V19H6a1,1,0,1,0,0,2H7.832a1,1,0,0,0,.326,0h7.674a1,1,0,0,0,.326,0H18a1,1,0,1,0,0-2H17V17.656a5,5,0,0,0-1.465-3.535L13.414,12l2.121-2.121A5,5,0,0,0,17,6.344V5h1a1,1,0,1,0,0-2H16.168a1,1,0,0,0-.326,0H8.154a1,1,0,0,0-.17-.014ZM9,5h6V6.344A2.994,2.994,0,0,1,14.5,8h-5A2.988,2.988,0,0,1,9,6.344Zm3,8.414,2.121,2.121A3,3,0,0,1,15,17.656V19H13.8a3.552,3.552,0,0,0-.83-1.277,1.4,1.4,0,0,0-1.945,0A3.544,3.544,0,0,0,10.2,19H9V17.656a2.991,2.991,0,0,1,.879-2.119Z",
    transform: "translate(1685 695.014)",
    fill: "#eaecf2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in_progress.53caa6fb663b771441455ff114f77a96.svg";
export { ForwardRef as ReactComponent };